import { Box, Paper, Typography } from '@mui/material';
import { CheckboxElement, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function DefinitionMetadataEditor() {
  const { formatMessage } = useIntl();

  return (
    <Paper sx={{ padding: 2, maxWidth: 'sm' }}>
      <Typography variant="h6" gutterBottom mb={2}>
        {formatMessage({
          id: 'audit.reportDefinitionEditor.metadata.title',
          defaultMessage: 'Información',
        })}
      </Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <TextFieldElement
          name="name"
          label={formatMessage({
            id: 'audit.reportDefinitionEditor.metadata.name',
            defaultMessage: 'Nombre',
          })}
          helperText={formatMessage({
            id: 'audit.reportDefinitionEditor.metadata.name.helper',
            defaultMessage: 'Nombre para identificar esta plantilla',
          })}
          fullWidth
          size="small"
        />
        <CheckboxElement
          name="isDefault"
          label={formatMessage({
            id: 'audit.reportDefinitionEditor.metadata.default',
            defaultMessage: 'Plantilla default',
          })}
        />
      </Box>
    </Paper>
  );
}
